module.exports = __webpack_public_path__ + "media/shared/assets/fonts/Inter-Medium-e78f8f072aa56924dc4d735fd1abeb68.woff";